/// <reference path="../../../app.definition.ts" />
interface IEcvServicesIconSvg {
    fill: string;

    init(): void;
}

class EcvServicesIconSvg implements IEcvServicesIconSvg {
    fill: string;

    static $inject = ['$rootScope'];
    constructor(
        private $rootScope: ng.IScope
    ) {
    }


    init(): void {


    }

}

function servicesIconSvg(): ng.IDirective {
    return {
        restrict: 'E',
        replace: true,
        template: `
                <span class="services-icon-svg">
                    <svg id="73d73432-9a19-4169-b5d6-4f2ddfb74f79" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 389.1 333.51">
                        <path id="service_left" fill="{{servicesIconVm.fill}}" d="M54.52,76.07A46.81,46.81,0,0,0,20.21,90.41,46.81,46.81,0,0,0,5.88,124.71V305.36a46.81,46.81,0,0,0,14.33,34.31A46.8,46.8,0,0,0,54.52,354h13.9V76.07Z" transform="translate(-5.88 -20.49)"/>
                        <path id="service_centre" fill="{{servicesIconVm.fill}}" d="M380.65,90.41a46.81,46.81,0,0,0-34.31-14.33h-13.9V354h13.9A48.93,48.93,0,0,0,395,305.36V124.71A46.81,46.81,0,0,0,380.65,90.41Z" transform="translate(-5.88 -20.49)"/>
                        <path id="service_right" fill="{{servicesIconVm.fill}}"
                              d="M283.81,76.07V41.33A20.76,20.76,0,0,0,263,20.49H137.9a20.76,20.76,0,0,0-20.84,20.84V76.07H89.26V354H311.6V76.07Zm-139-27.79H256V76.07H144.85Zm126,185.78-65.81,63.38a6.63,6.63,0,0,1-9.29,0l-65.91-63.59a34.73,34.73,0,0,1-2.91-2.75q-1.85-1.9-5.86-6.92a93.1,93.1,0,0,1-7.18-10.3,63.89,63.89,0,0,1-5.65-12.78,46.22,46.22,0,0,1-2.48-14.58q0-23.24,13.41-36.34t37.08-13.1a42.16,42.16,0,0,1,13.36,2.27,54.25,54.25,0,0,1,12.68,6.13q5.86,3.86,10.09,7.24a97.49,97.49,0,0,1,8,7.18,97.49,97.49,0,0,1,8-7.18q4.22-3.38,10.09-7.24a54.22,54.22,0,0,1,12.68-6.13,42.14,42.14,0,0,1,13.36-2.27q23.66,0,37.08,13.1t13.41,36.34Q295.08,209.88,270.89,234.07Z"
                              transform="translate(-5.88 -20.49)"/>
                    </svg>
                </span>
            `,
        controller: EcvServicesIconSvg,
        controllerAs: 'servicesIconVm',
        bindToController: {
            'fill': '@ecvFill'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvServicesIconSvg): void => {
            controller.init();
            // scope.$watch(() => {
            //     return !!controller.fill ? controller.fill : null;
            // }, (newVal, oldVal) => {
            //     if (!!newVal && newVal != oldVal) {
            //         controller.init();
            //     }
            // });
        }
    };
}

angular.module('eCareVault.common.directives').directive('ecvServicesIconSvg', servicesIconSvg);
